export enum PlatformDocumentType {
  IngestSpecification = "IngestSpecification",
}
